import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 *  Pipe de nettoyage d'une URL
 *
 * @class
 * @classdesc Pipe de nettoyage d'une URL
 * @public
 */
@Pipe({
  name: 'safeUrl',
  standalone: true,
})
export class SafeUrlPipe implements PipeTransform {
  /**
   * @constructor
   *
   * @param {DomSanitizer} sanitizer  Nettoyeur de code
   */
  constructor(private sanitizer: DomSanitizer) {}
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
